import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';

interface FeedItem {
  title: string;
  date: string;
  category: string;
}

@Component({
  selector: 'lohi-news-and-updates',
  templateUrl: './news-and-updates.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsAndUpdatesComponent implements OnInit {
  public feedItems$: Observable<FeedItem[]>;

  constructor() {}

  public ngOnInit(): void {
    this.feedItems$ = of([
      {
        title: 'LoHi™ releases admin web portal',
        date: new Date(2020, 9, 9, 9, 10, 32, 0).toISOString(),
        category: 'Software Release',
      },
    ]);
  }
}
